export interface SettingStateInterface {
  allowedFileUploadExtensions: string | null;
  maxFileUploadSizeInMegaBytes: number | null;
  dealerStoreUrl: string | null; 
  hrvRegistrations: string | null;
  dcrvRegistrations: string | null;
  initialized: boolean;
}

function state(): SettingStateInterface {
  return {
    allowedFileUploadExtensions: null,
    maxFileUploadSizeInMegaBytes: null,
    dealerStoreUrl: null,
    hrvRegistrations : null,
    dcrvRegistrations : null,
    initialized: false,
  }
}

export default state;
